import { useApiClient } from '../client'

export const STRIPE_READERS = '/core/v2/business_api/me/businesses/{businessId}/stripe/readers'

import type { StripeReadersResponse } from '@/api/types/stripe'

export function getStripeReaders (businessId: number | string) {
  const apiClient = useApiClient()

  return apiClient.get<StripeReadersResponse>({
    url: STRIPE_READERS,
    urlParams: {
      businessId,
    },
  })
}
